import React from 'react';
import styles from './styles/funding-recommendation.module.scss';

const FundingRecommendation = ({ min, max, activeUsers, advancesPerUser, volumePerAdvance }) => {
    const formatCurrency = (value) => {
        if (value === null || value === undefined) {
            return 'N/A';
        }
        if (value >= 1000000) {
            return `$${(value / 1000000).toFixed(2)}M`;
        }
        return `$${value.toLocaleString('en-US')}`;
    };

    return (
        <div className={styles.container}>
            <h3 className={styles.title}>Funding Account Recommendation</h3>
            
            <div className={styles.range}>
                {formatCurrency(min)} - {formatCurrency(max)}
            </div>

            <div className={styles.basedOn}>Based on</div>

            <div className={styles.metrics}>
                <div className={styles.metricRow}>
                    <span className={styles.label}>Active users</span>
                    <span className={styles.value}>{activeUsers !== null && activeUsers !== undefined ? activeUsers.toLocaleString() : 'N/A'}</span>
                </div>
                <div className={styles.metricRow}>
                    <span className={styles.label}>Advances per active user</span>
                    <span className={styles.value}>{advancesPerUser !== null && advancesPerUser !== undefined ? advancesPerUser : 'N/A'}</span>
                </div>
                <div className={styles.metricRow}>
                    <span className={styles.label}>Volume per advance</span>
                    <span className={styles.value}>${volumePerAdvance !== null && volumePerAdvance !== undefined ? volumePerAdvance : 'N/A'}</span>
                </div>
            </div>
        </div>
    );
};

export default FundingRecommendation;

